import React, { useState, useRef } from 'react';

const Circle = ({ x: initialX, y: initialY, color, initialRadius, mousePos, hoverRadius, maxScale }) => {
    const [position, setPosition] = useState({ x: initialX, y: initialY });
    const [velocity, setVelocity] = useState({
        x: (Math.random() - 0.5) * 2,
        y: (Math.random() - 0.5) * 2
    });
    const moveInterval = useRef(null);

    React.useEffect(() => {
        moveInterval.current = setInterval(() => {
            setPosition(prev => {
                const nextX = prev.x + velocity.x;
                const nextY = prev.y + velocity.y;
                
                let newVelX = velocity.x;
                let newVelY = velocity.y;

                if (nextX < 50 || nextX > window.innerWidth - 50) {
                    newVelX = -velocity.x;
                }
                if (nextY < 0 || nextY > window.innerHeight) {
                    newVelY = -velocity.y;
                }

                if (newVelX !== velocity.x || newVelY !== velocity.y) {
                    setVelocity({ x: newVelX, y: newVelY });
                }

                return {
                    x: nextX < 50 ? 50 : nextX > window.innerWidth - 50 ? window.innerWidth - 50 : nextX,
                    y: nextY < 0 ? 0 : nextY > window.innerHeight ? window.innerHeight : nextY
                };
            });
        }, 50);

        return () => clearInterval(moveInterval.current);
    }, [velocity]);

    // Calculate current size based on mouse position
    const dx = position.x - mousePos.x;
    const dy = position.y - mousePos.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const currentRadius = distance < hoverRadius
        ? initialRadius * (1 + maxScale * (1 - distance / hoverRadius))
        : initialRadius;

    // Create hexagon points
    const points = [];
    for (let i = 0; i < 6; i++) {
        const angle = (Math.PI / 3) * i;
        const x = currentRadius * Math.cos(angle);
        const y = currentRadius * Math.sin(angle);
        points.push(`${x},${y}`);
    }

    const hexStyle = {
        position: 'absolute',
        left: position.x,
        top: position.y,
        transform: 'translate(-50%, -50%)',
        width: currentRadius * 2,
        height: currentRadius * 2,
        pointerEvents: 'none',
    };

    return (
        <div style={hexStyle}>
            <svg width="100%" height="100%" viewBox="-100 -100 200 200">
                <polygon 
                    points={points.join(' ')} 
                    fill={color}
                    opacity="0.5"
                    style={{
                        transition: 'all 0.3s ease'
                    }}
                />
            </svg>
        </div>
    );
};

export default Circle;
